<form [formGroup]="addForm" (ngSubmit)="submit()">
  <div class="partner-form-title w-100 font-sans-bold">
    {{ 'partner.add.form.title' | translate }}
  </div>
  <div class="add-form-body">
    <div class="add-form-content">
      <div class="form-floating">
        <input formControlName="fullName" type="text" class="custom-field-form form-control field" id="customField" />
        <label class="display-name-custom-field font-size-10" for="floatingInputCustomField">{{
          'partner.add.fullname' | translate
        }}</label>
      </div>
      <div class="form-floating">
        <input formControlName="email" type="text" class="custom-field-form form-control field" id="customField" />
        <label class="display-name-custom-field font-size-10" for="floatingInputCustomField">{{
          'partner.add.form.email.label' | translate
        }}</label>
      </div>
    </div>
    <div class="mt-2 mx-3 error-message">
      <fgbcl-errors></fgbcl-errors>
    </div>
  </div>

  <div class="button-container d-flex justify-content-end form-buttons w-100">
    <button (click)="close(); $event.preventDefault()" class="btn btn-danger fw-bold">
      {{ 'partner.add.form.cancel.button' | translate }}
    </button>
    <button type="submit" [disabled]="addForm.invalid" class="btn btn-success fw-bold">
      {{ 'partner.add.form.submit.button' | translate }}
    </button>
  </div>
</form>
